"use strict";
'use client';
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var next_intl_1 = require("next-intl");
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var ui_components_1 = require("@l2p/ui-components");
var apps_shared_1 = require("@l2p/apps-shared");
var navigation_1 = require("next/navigation");
var react_2 = require("swiper/react");
var swiper_1 = require("swiper");
var Slide_1 = __importDefault(require("./Slide"));
require("./styles.scss");
var swr_hooks_1 = require("@l2p/swr-hooks");
var RecommendedGames = function (_a) {
    var _b, _c;
    var title = _a.title, category = _a.category, games = _a.games;
    var t = (0, next_intl_1.useTranslations)('translation');
    var breakpoints = (0, apps_shared_1.useBreakpoint)();
    var generateUrlWithLang = (0, apps_shared_1.useGenerateUrlWithLang)();
    var router = (0, navigation_1.useRouter)();
    var translateLocale = (0, swr_hooks_1.useLocaleTranslations)();
    var viewAllHandler = (0, react_1.useCallback)(function () {
        router.push(generateUrlWithLang("/games/".concat(category)));
    }, [router, generateUrlWithLang, category]);
    var slider = (0, react_1.useRef)(null);
    if (!games || (games === null || games === void 0 ? void 0 : games.length) === 0)
        return null;
    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.container },
        react_1.default.createElement("div", { className: styles_module_scss_1.default.inner },
            react_1.default.createElement("div", { className: styles_module_scss_1.default.header },
                react_1.default.createElement("span", null, translateLocale(title))),
            (games === null || games === void 0 ? void 0 : games.length) > 0 ? (react_1.default.createElement("div", { className: "recommended-games-slider" },
                react_1.default.createElement(react_2.Swiper, { onBeforeInit: function (swiper) {
                        slider.current = swiper;
                    }, className: styles_module_scss_1.default.swiper, modules: [swiper_1.Pagination, swiper_1.Navigation], loop: true, spaceBetween: breakpoints.mobile && ((_b = Object.keys(breakpoints)) === null || _b === void 0 ? void 0 : _b.length) > 0
                        ? 6
                        : 12, slidesPerView: breakpoints.mobile && ((_c = Object.keys(breakpoints)) === null || _c === void 0 ? void 0 : _c.length) > 0
                        ? 3
                        : breakpoints.xl
                            ? 6
                            : 5, pagination: false, navigation: true, initialSlide: 0, autoplay: false }, games.map(function (game, idx) { return (react_1.default.createElement(react_2.SwiperSlide, { key: "slideRecentFavorites".concat(idx) },
                    react_1.default.createElement(Slide_1.default, { game: game }))); })),
                react_1.default.createElement("div", { className: styles_module_scss_1.default.loadMoreButtonWrapper },
                    react_1.default.createElement(ui_components_1.LoadMoreButton, { onClick: viewAllHandler }, t('viewAll'))))) : (react_1.default.createElement("div", { className: styles_module_scss_1.default.emptyGamesContainer },
                react_1.default.createElement(ui_components_1.EmptyGames, null))))));
};
exports.default = RecommendedGames;
